import React, { useState, useEffect } from 'react';
import './Dropdown.css';
import LoadingOverlay from '../components/LoadingOverlay';

export default function ContasPagarDropdown() {
  console.log('🔧 ContasPagarDropdown renderizando...');
  
  const [contasPagar, setContasPagar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Estados para filtro
  const [filtro, setFiltro] = useState('fornecedor');
  const [valorFiltro, setValorFiltro] = useState('');
  const [dropdownAberto, setDropdownAberto] = useState(false);

  useEffect(() => {
    // Aqui você pode adicionar a lógica para carregar as contas a pagar
    console.log('📊 Carregando contas a pagar...');
    setLoading(false);
  }, []);

  // Fecha todos os popups quando AjudaWidget solicitar
  useEffect(() => {
    const handler = () => {
      setDropdownAberto(false);
    };
    window.addEventListener('contaspagar-fechar-todos-popups', handler);
    return () => window.removeEventListener('contaspagar-fechar-todos-popups', handler);
  }, []);

  const opcoesFiltro = [
    { valor: 'fornecedor', label: 'Fornecedor' },
    { valor: 'valor', label: 'Valor' },
    { valor: 'vencimento', label: 'Data Vencimento' },
    { valor: 'status', label: 'Status' }
  ];

  const limparFiltro = () => {
    setValorFiltro('');
  };

  return (
    <div className="container-geral fundo-branco" style={{ 
      minHeight: '100vh', 
      background: '#f0f0f0', 
      padding: '20px'
    }}>
      
      {/* Filtro de contas a pagar */}
      <div style={{
        width: '100%',
        maxWidth: 1200,
        margin: '0 auto 24px auto',
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        padding: '0 20px',
        justifyContent: 'center'
      }}>
        <label style={{ 
          color: '#333', 
          fontSize: '16px', 
          fontWeight: '500',
          whiteSpace: 'nowrap'
        }}>
          Filtrar por:
        </label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <input
              type="text"
              style={{
                padding: '10px 15px',
                paddingRight: valorFiltro ? '40px' : '15px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                fontSize: '14px',
                minWidth: '250px',
                outline: 'none'
              }}
              placeholder={`Filtrar por ${opcoesFiltro.find(opcao => opcao.valor === filtro)?.label || 'campo'}`}
              value={valorFiltro}
              onChange={(e) => setValorFiltro(e.target.value)}
            />
            {valorFiltro && (
              <button
                onClick={limparFiltro}
                title="Limpar filtro"
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  color: 'rgb(235, 133, 0)',
                  border: 'none',
                  width: '20px',
                  height: '20px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  lineHeight: '1',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  outline: 'none',
                  boxShadow: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgb(235, 133, 0)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgb(235, 133, 0)';
                }}
                onFocus={(e) => {
                  e.target.style.background = 'transparent';
                  e.target.style.color = 'rgb(235, 133, 0)';
                  e.target.style.outline = 'none';
                }}
              >
                ×
              </button>
            )}
          </div>
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setDropdownAberto(!dropdownAberto)}
              style={{
                padding: '10px 15px',
                backgroundColor: 'rgb(235, 133, 0)',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: '200px',
                justifyContent: 'space-between'
              }}
            >
              {opcoesFiltro.find(opcao => opcao.valor === filtro)?.label || 'Selecione'}
              <span style={{ transform: dropdownAberto ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>▼</span>
            </button>
            {dropdownAberto && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: 'rgb(235, 133, 0)',
                border: '1px solid rgb(235, 133, 0)',
                borderRadius: '5px',
                marginTop: '2px',
                zIndex: 1000,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                {opcoesFiltro.map(opcao => (
                  <div 
                    key={opcao.valor}
                    onClick={() => {
                      setFiltro(opcao.valor);
                      setDropdownAberto(false);
                    }}
                    style={{ 
                      padding: '10px 15px', 
                      cursor: 'pointer',
                      borderBottom: '1px solid rgba(255,255,255,0.2)',
                      color: 'white'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    {opcao.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Loading */}
      {loading && (
        <div style={{ 
          textAlign: 'center', 
          padding: '40px', 
          color: '#666',
          backgroundColor: 'white',
          marginTop: '10px'
        }}>
          Carregando contas a pagar...
        </div>
      )}

      {/* Error */}
      {error && (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px', 
          color: '#ff0000',
          backgroundColor: '#ffebee',
          borderRadius: '5px',
          margin: '20px 0'
        }}>
          {error}
        </div>
      )}

      {/* Lista de contas a pagar */}
      {!loading && !error && (
        <div className="oportunidade-cards">
          <div style={{ 
            textAlign: 'center', 
            padding: '40px', 
            color: '#666',
            backgroundColor: 'white',
            marginTop: '10px'
          }}>
            Componente Contas a Pagar - Em desenvolvimento
          </div>
        </div>
      )}

      <LoadingOverlay isLoading={loading} message="Processando..." />
    </div>
  );
}
